import withHeader from "hocs/withHeader";
import Head from "next/head";
import { Suspense, useContext } from "react";
import dynamic from "next/dynamic";
import withFooter from "hocs/withFooter";
import { useRouter } from "next/router";
import Loader from "semantic-ui-react/dist/commonjs/elements/Loader";
import { BrowserUtils } from "@utils";
import { ParsedUrlQuery } from "querystring";
import { useTalentQuery } from "@api";
import TalentModel from "../../../app__Legacy/models/talents/Talent";
import { VingletLoader } from "@common";
import { UserProfileContext } from "@context";
import {useLocales} from "@libs";

const DynamicUnitTalent = dynamic(() => import("containers/UnitTalent/UnitTalent"), {
	suspense: true,
});

const TalentPage = ({ query }: { query: ParsedUrlQuery }) => {
	const { slug: talentSlug } = query;
	const { user, userProfile } = useContext(UserProfileContext);
	const { data: talent, isLoading: isTalentLoading, isError: isTalentError } = useTalentQuery(String(talentSlug));
	const {currentShortLocale} = useLocales();

	const router = useRouter();

	if (isTalentLoading) {
		return (
			<Loader
				className="margin-4-top block"
				active
				inline={"centered"}
			/>
		);
	}

	if (isTalentError) {
		router.push("/500");
		return <></>;
	}

	if (BrowserUtils.isRunningOnBrowser() && !talent) {
		router.push("/404");
		return <></>;
	}

	return (
		<>
			<Head>
				<title> Vinglet - {talent.title} </title>
			</Head>
			<Suspense fallback={<VingletLoader />}>
				<DynamicUnitTalent
					user={{
						isLogged: Boolean(user?.id),
					}}
					userProfile={userProfile}
					talent={TalentModel.generateFromAPI(talent)}
					currentShortLocale={currentShortLocale}
				/>
			</Suspense>
		</>
	);
};

export default withHeader(withFooter(TalentPage));
